import { router } from '@inertiajs/vue3';

export function useMotoristaNavigation() {
    const getAreaMotoristaRoute = () => route('motorista');
    const getRetiradaVeiculoRoute = () => route('motorista.retirada');
    const getDevolucaoVeiculoRoute = () => route('motorista.devolucao');

    const goToAreaMotorista = () => router.visit(getAreaMotoristaRoute());
    const goToRetiradaVeiculo = () => router.visit(getRetiradaVeiculoRoute());
    const goToDevolucaoVeiculo = () => router.visit(getDevolucaoVeiculoRoute());

    return { getAreaMotoristaRoute, getRetiradaVeiculoRoute, getDevolucaoVeiculoRoute, goToAreaMotorista, goToRetiradaVeiculo, goToDevolucaoVeiculo };
}
